import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { UserAuthenticatedLayout } from "@/layouts/AuthenticatedLayout/UserAuthenticatedLayout";
import {
  authenticatedRouting,
  levelsNestedRoutes,
} from "@/modules/router/routings/authenticatedRouting";
import { Button } from "@/modules/theme/components/Button/Button";
import { Base404NotFoundLayout } from "@/pages/404NotFound/Base404NotFoundLayout";

import { LevelsList } from "./components/LevelsList/LevelsList";
import { LevelsNav } from "./components/LevelsNav/LevelsNav";
import { Ranking } from "./components/Ranking/Ranking";
import { createLevelsPageStyles } from "./createLevelsPageStyles";

const translationNamespace = "pages/LevelsPage";

const Routes = levelsNestedRoutes.Routes;

export const LevelsPage = () => {
  const { t } = useTranslation(translationNamespace);
  const classes = createLevelsPageStyles();
  const history = useHistory();

  return (
    <UserAuthenticatedLayout>
      <LevelsNav />
      <Routes
        components={{
          levels: () => <LevelsList />,
          ranking: () => <Ranking />,
        }}
        fallthroughComponent={() => (
          <Base404NotFoundLayout className={classes.notFound}>
            <Button
              onClick={() =>
                history.push(authenticatedRouting.buildUrl("tasks"))
              }
            >
              {t("Back to Tasks")}
            </Button>
          </Base404NotFoundLayout>
        )}
      />
    </UserAuthenticatedLayout>
  );
};
